<template>
    <notes-store
        v-slot="{
            sid,
            is_loading: is_saving,
            store,
            error
        }"
        @success="onNotesStoreSuccess"
    >
        <div class="bg-white rounded shadow">
            <header class="flex items-center h-16 px-4 bg-white border-b rounded-t sm:px-6">
                <h3 class="flex-grow text-base font-normal">Notes</h3>

                <div class="flex-none w-6 h-6 mr-3">
                    <base-tooltip>
                        <template v-slot:trigger>
                            <base-svg
                                name="icon-view-visible"
                                class="w-full h-full fill-primary-grey fill-secondary-grey-darkest"
                            />
                        </template>

                        <template v-slot:tooltip>
                            Notes are only visible to you.
                        </template>
                    </base-tooltip>
                </div>
            </header>

            <base-form @submit="store(form)">
                <validator-alert :sid="sid" />

                <textarea
                    v-model="form.body"
                    class="block w-full px-4 py-3 rounded sm:px-6 min-h-3xs focus:shadow-outline focus:outline-none text-grey-darker"
                    placeholder="Make any notes here - they're private."
                />

                <div
                    v-if="show_save"
                    class="flex flex-col px-4 py-3 text-right bg-grey-bg sm:px-6 md:flex-row-reverse"
                >
                    <base-button
                        :is-loading="is_saving"
                        type="submit"
                        class="w-full btn-blue md:w-auto"
                        :class="[
                            has_saved ? 'btn-green' : 'btn-blue'
                        ]"
                    >
                        <base-svg
                            v-if="has_saved"
                            name="icon-check-circle"
                            class="absolute w-6 h-6 fill-primary-green fill-secondary-white"
                        />

                        <span
                            :class="{
                                'invisible': has_saved
                            }"
                        >
                            Save Note
                        </span>
                    </base-button>

                    <button
                        type="button"
                        class="mt-3 text-center btn md:mt-0 md:mr-3"
                        @click.prevent="undo"
                    >
                        Cancel
                    </button>
                </div>
            </base-form>

            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
            />
        </div>
    </notes-store>
</template>

<script>
    import _ from 'lodash'
    import NotesStore from './notes-store'

    export default {
        components: {
            NotesStore
        },
        props: {
            note: {
                validator: value => typeof value === 'object' || value === null,
                required: true
            },
            notable: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_save: false,
                has_saved: false,
                form: {
                    notable: _.pick(this.notable, ['object', 'uuid']),
                    body: _.get(this.note, 'body')
                },
                body: _.get(this.note, 'body')
            }
        },
        watch: {
            'form.body' () {
                this.show_save = true
            }
        },
        methods: {
            undo () {
                this.form.body = this.body

                setTimeout(() => {
                    this.show_save = false
                }, 0)
            },
            onNotesStoreSuccess ({ data: note }) {
                this.body = note.body

                this.has_saved = true

                setTimeout(() => {
                    this.has_saved = false
                }, 2500)
            }
        }
    }
</script>
